import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ComparisonSection() {
  return <section className="w-full bg-[#f8f8f8] py-16 md:py-24 border-t border-gray-200" data-id="element-115" data-mp="3e5zjyd3vblpd">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-116" data-mp="39dg5zf19qok1">
        <div className="text-center mb-16" data-id="element-117" data-mp="34fxubgvv9v8c">
          <h2 className="text-[1.625rem] md:text-[2.5rem] font-semibold text-[#111111] leading-[1.2] mb-6" data-id="element-118" data-mp="34ev295mt5mqu">
            Why Caveo — and why nothing else fills this gap
          </h2>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-119" data-mp="2ve6swo8d0aka">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-120" data-mp="2qfvhi92f1rzy">
            {/* The Others */}
            <div className="bg-white rounded-2xl p-8 border-2 border-gray-300" data-id="element-121" data-mp="2lgsdmry69rtk">
              <div className="text-center mb-6" data-id="element-122" data-mp="2lj527nyfr0fl">
                <span className="inline-block bg-gray-200 text-gray-600 px-4 py-2 rounded-lg font-bold text-sm uppercase tracking-wide" data-id="element-123" data-mp="onh1jfjfmxm6">
                  Typical Security Apps
                </span>
              </div>
              <div className="space-y-4" data-id="element-124" data-mp="3adjiiobvi4k3">
                <div className="flex items-center" data-id="element-125" data-mp="3egpywosp9c4a">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-126" data-mp="3ehhlja4bjzif">
                    <XIcon className="w-4 h-4 text-gray-400" data-id="element-127" data-mp="30j1d9eqt60y6" />
                  </div>
                  <span className="text-gray-600" data-id="element-128" data-mp="35gjkn0p6g842">
                    Scare you into buying more
                  </span>
                </div>
                <div className="flex items-center" data-id="element-129" data-mp="1z1fj10shf7c">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-130" data-mp="1yrmf4kg6rxf">
                    <XIcon className="w-4 h-4 text-gray-400" data-id="element-131" data-mp="3jdyhgqhrfi62" />
                  </div>
                  <span className="text-gray-600" data-id="element-132" data-mp="3od18v84thpvk">
                    Drown you in tech jargon
                  </span>
                </div>
                <div className="flex items-center" data-id="element-133" data-mp="kqaqzfu4ee1k">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-134" data-mp="kr3rhz2hk7b9">
                    <XIcon className="w-4 h-4 text-gray-400" data-id="element-135" data-mp="ujews1ttajek" />
                  </div>
                  <span className="text-gray-600" data-id="element-136" data-mp="pkljoaifsuex">
                    Monitor you without teaching you
                  </span>
                </div>
                <div className="flex items-center" data-id="element-137" data-mp="gmrpp685acux">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-138" data-mp="goclez6741ud">
                    <XIcon className="w-4 h-4 text-gray-400" data-id="element-139" data-mp="6wgmxn0769pm" />
                  </div>
                  <span className="text-gray-600" data-id="element-140" data-mp="1x3oe4zyre77">
                    Leave you dependent on their tools
                  </span>
                </div>
              </div>
            </div>

            {/* Caveo */}
            <div className="bg-white rounded-2xl p-8 border-2 border-[#631bb7]" data-id="element-141" data-mp="3p1jurfhjsztq">
              <div className="text-center mb-6" data-id="element-142" data-mp="3p3mmq529h313">
                <span className="inline-block bg-[#631bb7] text-white px-4 py-2 rounded-lg font-bold text-sm uppercase tracking-wide" data-id="element-143" data-mp="3k41jvjjz0aj3">
                  Caveo
                </span>
              </div>
              <div className="space-y-4" data-id="element-144" data-mp="24ig1qd1ss45o">
                <div className="flex items-center" data-id="element-145" data-mp="24llt5yxwfi4k">
                  <div className="w-8 h-8 bg-[#631bb7] bg-opacity-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-146" data-mp="28mntyk7gs28n">
                    <CheckIcon className="w-4 h-4 text-[#631bb7]" data-id="element-147" data-mp="2dictwonebl5h" />
                  </div>
                  <span className="text-[#111111] font-medium" data-id="element-148" data-mp="1gs3lmewef140">
                    Honest advice — no upsells, no kickbacks
                  </span>
                </div>
                <div className="flex items-center" data-id="element-149" data-mp="1pu34lcqz4f9l">
                  <div className="w-8 h-8 bg-[#631bb7] bg-opacity-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-150" data-mp="1ull5y1wwshv3">
                    <CheckIcon className="w-4 h-4 text-[#631bb7]" data-id="element-151" data-mp="x55zkbbrweys" />
                  </div>
                  <span className="text-[#111111] font-medium" data-id="element-152" data-mp="124iiwm3fr3wm">
                    Guides your family through what to do, step by step
                  </span>
                </div>
                <div className="flex items-center" data-id="element-153" data-mp="2zt4fe4ln4u8m">
                  <div className="w-8 h-8 bg-[#631bb7] bg-opacity-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-154" data-mp="2zupe86ezmzca">
                    <CheckIcon className="w-4 h-4 text-[#631bb7]" data-id="element-155" data-mp="38tsxbae5neqs" />
                  </div>
                  <span className="text-[#111111] font-medium" data-id="element-156" data-mp="3nigpr7spf8ci">
                    Makes sure the important things actually get done
                  </span>
                </div>
                <div className="flex items-center" data-id="element-157" data-mp="3ilghcq8dtti8">
                  <div className="w-8 h-8 bg-[#631bb7] bg-opacity-10 rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-158" data-mp="e0rkkl9wt12">
                    <CheckIcon className="w-4 h-4 text-[#631bb7]" data-id="element-159" data-mp="3sibdx3l3hjtv" />
                  </div>
                  <span className="text-[#111111] font-medium" data-id="element-160" data-mp="225m8kzbji279">
                    Builds habits that protect your family long-term
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center" data-id="element-161" data-mp="1s15x0i53f799">
            <Link to="/onboarding" className="bg-[#631bb7] text-white px-8 py-4 rounded-lg font-medium text-sm inline-flex items-center justify-center no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-162" data-mp="1s047x9r8sk8j">
              Start Now
            </Link>
          </div>
        </div>
      </div>
    </section>;
}